import { FACTOR_ENUMS, BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';

const {
  PAYMENT_HISTORY,
  ACCOUNT_MIX,
  CREDIT_AGE,
  CREDIT_INQUIRIES,
  CREDIT_USAGE,
} = FACTOR_ENUMS;

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

export const factorMapping = new Map([
  [PAYMENT_HISTORY, 'Payment History'],
  [ACCOUNT_MIX, 'Credit Depth: Account Mix'],
  [CREDIT_AGE, 'Credit Depth: Age'],
  [CREDIT_INQUIRIES, 'Recent Credit'],
  [CREDIT_USAGE, 'Credit Usage'],
]);

export const providerMapping = new Map([
  [ALL, 'TransUnion'],
  [TRANS_UNION, 'TransUnion'],
  [EQUIFAX, 'Equifax'],
  [EXPERIAN, 'Experian'],
]);
